<button
  type="button"
  class="analysis-document-pill"
  [class.is-approved]="statusKey === 'approved'"
  [class.is-rejected]="statusKey === 'rejected'"
  [class.is-pending]="statusKey === 'pending'"
  [class.is-unknown]="statusKey === 'unknown'"
  [attr.data-cy]="'submitted-doc-' + document.id"
  [attr.data-status]="statusKey"
  (click)="documentSelect.emit()">
  <span class="analysis-document-pill__bar" aria-hidden="true"></span>

  <span class="analysis-document-pill__year" *ngIf="showYear && document.year">
    {{ document.year }}
  </span>

  <img class="analysis-document-pill__icon" [src]="iconSource" [alt]="document.fileExtension" />

  <span class="analysis-document-pill__name" tooltipPosition="left" [pTooltip]="submissionTooltip">
    {{ document.fileNameWithoutTimestamp }}
  </span>

  <span
    class="analysis-document-pill__status"
    [attr.data-cy]="'doc-status-' + document.id"
    [attr.data-status]="statusKey"
    tooltipPosition="top"
    [pTooltip]="analysisTooltip">
    <span class="analysis-document-pill__dot" aria-hidden="true"></span>
    {{ statusLabel }}
  </span>
</button>
